function HelperService() {

    this.setUndefinedToNull = function(obj, values) {
        _.forEach(values, function(value) {
            if (obj[value] === undefined) {
                obj[value] = null;
            }
        });
    };


    this.getChangedData = function(original, edited, values) {
        var keysInOriginal = Object.keys(original);
        var keysInEdited = Object.keys(edited);
        _.forEach(keysInEdited, function(editKey) {
            if (!_.find(keysInOriginal, function(originalKey) { return originalKey === editKey; })) {
                original[editKey] = undefined;
            }
        });

        return this.findDiffs(_.pick(original, values), edited);
    };

    this.findDiffs = function(original, edited) {
        var diffs = {};
        for (var key in original) {
            var orgvalue = original[key];
            var editedvalue = edited[key];
            if (Array.isArray(orgvalue) || Array.isArray(editedvalue)) {
                if (!_.isEqual(orgvalue, editedvalue)) {
                    diffs[key] = editedvalue;
                }
            } else {
                if (!angular.equals(orgvalue, editedvalue)) {
                    diffs[key] = editedvalue;
                }
            }
        }
        return diffs;
    };
}

angular
    .module('services.helperService', [])
    .service('HelperService', HelperService);
